import A11yDialog from 'a11y-dialog';

let dialog;

export function statusDialog() {
  if (!dialog) {
    const dialogEl = document.getElementById('success-dialog');
    dialog = new A11yDialog(dialogEl);
  }

  return dialog;
}
